import { ComparisonTableAction } from "../comparison_table/comparison_table_action";
import { Analytics } from "./analytics";

export class ComparisonTableCheckAnalytics extends Analytics {

  constructor() {
    super();
    ComparisonTableAction.CHECK_COMPARISON_EVENT.on((data) => {
      this.run(() => {
        const fName = '比較対象を選択';
        const linkAnalyticsData = {
          server: 'club/pc',
          fName: fName,
          club: {
            server: 'club/pc',
            prop5: fName,
          },
        }
        window.sc_trackLinkAll(linkAnalyticsData, data.target, 'o', data.linkName);
      });
    });
  }
}
